<template>
  <v-container fluid>
    <v-row>
      <v-col xs12 md8 offset-md2>
        <v-data-table
            v-bind:headers="headers"
            v-model="cart"
            hide-actions
            class="elevation-1">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-right">
              <v-select
                v-bind:items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                v-model="props.item.quantity"
                label="Select"
                light
                single-line
                auto
              />
            </td>
            <td class="text-xs-right">{{ props.item.cost }}</td>
          </template>
        </v-data-table>
        <div class="text-xs-right mt-3">
          Total: {{ total }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col xs12 class="text-xs-center mt-3">
      <v-btn
        v-bind:loading="loading"
        v-on:click.native="loader = 'loading'"
        v-bind:disabled="loading"
        class="blue-grey">
        下一步
        <v-icon right>keyboard_arrow_right</v-icon>
      </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {

    name: 'Shop',

    data () {
      return {
        loading: false,
        headers: [
          {
            text: 'Name',
            sortable: true,
            left: true,
            value: 'name'
          },
          {
            text: 'Quantity',
            sortable: false,
            value: 'quantity'
          },
          {
            text: 'Cost',
            sortable: false,
            value: 'cost'
          }
        ],
        items: [
          {
            value: false,
            id: 1,
            name: '我的第一本玩具書',
            quantity: 1,
            cost: 24
          },
          {
            value: false,
            id: 2,
            name: '旅遊日語',
            quantity: 1,
            cost: 100
          }
        ]
      }
    },

    computed: {
      total () {
        return this.cart.reduce((prev, el) => {
          return prev + el.quantity * el.cost
        }, 0)
      },

      ...mapGetters([
        'cart'
      ])
    }
  }
</script>

<style lang="scss" scoped>
  .table__overflow {
    overflow-x: initial !important;
    overflow-y: initial !important;
  }
</style>



// WEBPACK FOOTER //
// Cart.vue?7bd24b1e